import { TestsContainerComponent } from './tests-container/tests-container.component';
import { AuthGuard } from 'src/app/shared/_guards/auth.guard';

export const TESTS_ROUTES =[
  { path: '',component: TestsContainerComponent, canActivate: [AuthGuard] },
];
